export const SettingsRoutes = {
    Settings: 'cv/profile',
    ChangePassword: 'cv/profile/change-password',
    ChangeLogin: 'cv/profile/change-login',
    CreateLogin: 'cv/profile/create-login',
};
